import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { JSX } from '@redneckz/uni-jsx';
import { useEffect, useRef } from '@redneckz/uni-jsx/lib/hooks';
import { style } from '../../utils/style.js';
import { Loader } from '../Loader/Loader.js';
import { renderClusterer } from './renderClusterer.js';
import { renderUserGeolocation } from './renderUserGeolocation.js';
import { useYandexMaps } from './useYandexMaps.js';
import { ZoomButton } from './ZoomButton.js';
const DEFAULT_CENTER_COORDS = [55.753995, 37.614069];
// TODO: Поле для поиска: невыяснено среди каких данных делать поиск (искать в имени офиса, в адресе, метро и т.д.).
//       Сейчас реализован поиск среди тестовых данных
// TODO: Также выяснить что делать когда ничего не найдено
// TODO: На макетах также когда есть поле поиска нет кнопки открыть на карте.
export const YandexMap = JSX(({ points, className = '', zoom = 5, isLoad }) => {
    const map = useRef(null);
    const yandexMaps = useYandexMaps();
    useEffect(() => {
        if (map.current) {
            renderClusterer({ yandexMaps, map: map.current, points, isLoad });
            map.current.setCenter(getCenterPoint(points));
        }
        else {
            yandexMaps?.ready(() => {
                // Ready function may be called few times, but must be called once
                if (map.current) {
                    renderClusterer({ yandexMaps, map: map.current, points, isLoad });
                    return;
                }
                map.current = new yandexMaps.Map('map', {
                    center: getCenterPoint(points),
                    zoom,
                    controls: [],
                    suppressMapOpenBlock: true,
                });
                renderClusterer({ yandexMaps, map: map.current, points, isLoad });
            });
        }
    }, [yandexMaps, points, zoom, isLoad]);
    if (!yandexMaps) {
        return null;
    }
    const zIndex = 'z-10';
    return (_jsxs("div", { id: "map", className: style('relative', 'w-full', className), children: [isLoad ? _jsx(Loader, {}) : null, _jsxs("div", { className: style('absolute right-2 top-52 z-10 w-12 overflow-hidden border border-transparent rounded-md', zIndex), children: [_jsx(ZoomButton, { yandexMaps: map }), _jsx(ZoomButton, { yandexMaps: map, direction: "out" })] }), renderUserGeolocation(map, yandexMaps, style('right-2 top-80', zIndex))] }));
});
const getCenterPoint = (points) => {
    const centerCoords = [
        getArraySumAndAverage(mapByIndex(points, 0)),
        getArraySumAndAverage(mapByIndex(points, 1)),
    ];
    return centerCoords.every((_) => _) ? centerCoords : DEFAULT_CENTER_COORDS;
};
const mapByIndex = (points, index) => points.map((_) => _.coords?.[index]);
const getArraySumAndAverage = (arr) => arr.length && arr.reduce((a, b) => a + b) / arr.length;
//# sourceMappingURL=YandexMap.js.map